module.exports = __webpack_public_path__ + "media/img/new-detail-1-90b3ceee.png";